<template>
    <div>
        <h3>{{ 'show.upcoming' | translate }}:</h3>
        <div class="card card-dark border-dark mb-4">
            <div class="card-body">
                <ul v-if="hasItems" class="list-unstyled">
                    <li v-for="(item, index) in items"
                        class="media" :class="{ 'mt-5': index > 0 }">
                        <div class="media-body">
                            <div class="row">
                                <div class="col-lg-9">
                                    <h4 class="mt-0 mb-1 text-primary text-uppercase">{{ getTitle(item) }}</h4>
                                    <hr/>
                                    <p v-if="hasDetails(item)">{{ item.name }} &nbsp;|&nbsp; {{ item.location }}</p>
                                </div>
                                <div class="col-lg-3 text-lg-right align-self-center">
                                    <a v-if="item.image" :href="item.image"
                                       class="btn btn-outline-primary btn-block"
                                       data-toggle="lightbox">
                                        {{ 'show.poster' | translate }}
                                    </a>
                                    <button v-if="item.booking_url" type="button"
                                            class="btn btn-outline-primary btn-block"
                                            @click="showBookingLinks(index)">
                                        {{ 'show.tickets' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <p v-else class="no-data">{{ 'no_data' | translate }}</p>
            </div>
        </div>

        <h3>{{ 'show.previous' | translate }}:</h3>
        <div class="card card-dark border-dark mb-4">
            <div class="card-body">
                <ul v-if="hasPrevItems" class="list-unstyled">
                    <li v-for="(item, index) in prevItems"
                        class="media" :class="{ 'mt-5': index > 0 }">
                        <div class="media-body">
                            <div class="row">
                                <div class="col-lg-9">
                                    <h4 class="mt-0 mb-1 text-primary text-uppercase">{{ getTitle(item, true) }}</h4>
                                    <hr/>
                                    <p v-if="hasDetails(item)">{{ item.name }} &nbsp;|&nbsp; {{ item.location }}</p>
                                </div>
                                <div class="col-lg-3 text-lg-right align-self-center">
                                    <a v-if="item.image" :href="item.image"
                                       class="btn btn-outline-primary btn-block"
                                       data-toggle="lightbox">
                                        {{ 'show.poster' | translate }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <p v-else class="no-data">{{ 'no_data' | translate }}</p>
            </div>
        </div>

        <vue-modal ref="bookingLinksModal"
                   :show-header="false"
                   :show-footer="false"
                   :centered="true">
            <button slot="header"
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>

            <div v-if="hasItemSelected" slot="body" class="text-center">
                <a v-for="link in getPartnerLinks(selectedItem)"
                   :href="link.url" target="_blank"
                   class="partner-link" v-bind:class="'partner-link--'+link.partner">
                    <img :src="`/images/partners/${link.partner}-logo.png`" :alt="link.partner"/>
                </a>
            </div>
        </vue-modal>
    </div>
</template>

<script>
    import {formatDatesRange} from '../modules/date-time-formatting'
    import 'ekko-lightbox'
    import VueModal from './Modal'

    export default {
        data() {
            return {
                items: [],
                prevItems: [],
                selectedItemIndex: -1
            }
        },
        computed: {
            hasItems() {
                return this.items.length > 0;
            },
            hasPrevItems() {
                return this.prevItems.length > 0;
            },
            hasItemSelected() {
                return this.hasItems && this.selectedItemIndex !== -1
            },
            selectedItem() {
                return this.hasItemSelected ? this.items[this.selectedItemIndex] : null
            }
        },
        components: {
            'vue-modal': VueModal
        },
        created() {
            this.loadItems();
            this.loadPrevItems();
        },
        mounted() {
            $(this.$el).on('click', '[data-toggle="lightbox"]', function (event) {
                event.preventDefault();
                $(this).ekkoLightbox();
            })
        },
        methods: {
            loadItems() {
                axios.get('/api/show')
                    .then(response => this.items = response.data.data)
                    .catch(error => console.error(error))
            },
            loadPrevItems() {
                axios.get('/api/show?prev=1')
                    .then(response => this.prevItems = response.data.data)
                    .catch(error => console.error(error))
            },
            getTitle(item, showYear = false) {
                let formattedDate = formatDatesRange(
                    item.start_date,
                    item.end_date,
                    'dddd D MMMM'
                );
                if (showYear) {
                    formattedDate += ' (' + (new Date(item.end_date)).getFullYear() + ')';
                }
                return formattedDate;
            },
            getPartnerLinks(item) {
                const links = [];
                const regexp = /\/\/(.+?)\./;
                for (let i = 0, l = item.booking_url.length; i < l; i++) {
                    const url = item.booking_url[i].url;
                    const found = url.match(regexp);
                    links.push({partner: found[1], url: url});
                }
                return links;
            },
            hasDetails(item) {
                return item.name.length > 0 && item.location.length > 0
            },
            showBookingLinks(index) {
                this.selectedItemIndex = index;
                this.$refs.bookingLinksModal.show();
            }
        }
    }
</script>

<style lang="scss">
    @import "~ekko-lightbox/dist/ekko-lightbox.css";
    @import "resources/assets/sass/variables";

    h3 {
        padding: 0.5rem 1.25rem;

        color: $trans-white-65;
        font-size: 1.2rem;
    }

    .no-data {
        margin: 0;
    }

    .partner-link {
        display: block;

        margin: 12px 0 25px;

        &:last-child {
            margin-bottom: 12px;
        }

        /*transform: scale(1);
        &:active {
            transform: scale(0.9);
        }*/

        img {
            max-width: 250px;
            max-height: 100px;
            box-shadow: 7px 8px 20px 0 #8c8c8c;
        }

        &--bilethouse img {
            background-color: #fff;
        }

        &--palace-ukraine img {
            background-color: #201d76;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ShowsList.vue